/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Credit estimate for enrolling a cohort. ``credits_required`` is an upper
 * bound (reveal markers only grow; empty reveals still count as revealed).
 */
export interface EnrollmentRevealEstimateResponse {
  total: number;
  already_revealed: number;
  to_reveal: number;
  credits_required: number;
  balance: number;
  sufficient: boolean;
}
